import React, { useEffect, useContext, useReducer, useState, useCallback, useMemo } from "react";
import { dataFetchReducer } from "../../Utils/requestUtils";
import AuthContext from "../../../context/auth-context"
import { useParams } from "react-router-dom";
import axios from "axios";
import {CircularProgress } from '@material-ui/core'
import ClientProfile from "./ClientProfile/ClientProfile";
import ClientProfileAnalyst from "./ClientProfile/ClientProfileAnalyst";
import AnalystSnackBar from "./AnalystSnackBar/AnalystSnackBar"
import CNHOCRCard from "../Cards/CNHOCRCard/CNHOCRCard";
import RGOCRCard from "../Cards/RGOCRCard/RGOCRCard";
import CNHProfile from "./CNHProfile/CNHProfile";
import ProcessesCard from "./Cards/ProcessesCard/ProcessesCard"
import Summary from "./Summary/Summary";
import Indicators from "./Indicators/Indicators"
import DeviceScan from "./DeviceScan/DeviceScan"
import PeopleRelatedCard from "./Cards/PeopleRelatedCard/PeopleRelatedCard"
import CompaniesRelatedCard from "./Cards/CompaniesRelatedCard/CompaniesRelatedCard"
import MediaCard from "./Cards/MediaCard/MediaCard"
import ClipLaunderingCard from "./Cards/ClipLaunderingCard/ClipLaunderingCard"
import ProcessesEDPCard from "../../../components/Cards/ProcessesEDP";
import SportsExposureCard from "./Cards/SportsExposureCard/SportsExposureCard";
import DAFNCard from "./Cards/DAFNCard/DAFNCard"
import IbamaCard from "./Cards/IbamaCard/IbamaCard"
import ProtestsCard from "./Cards/ProtestsCard/ProtestsCard"
import SlaveryCard from "./Cards/SlaveryCard/SlaveryCard"
import OFACCard from "./Cards/OFACCard/OFACCard"
import UNSCCard from "./Cards/UNSCCard/UNSCCard"
import PEPCard from "./Cards/PEPCard/PEPCard"
import PEPRelatedCard from "./Cards/PEPRelatedCard/PEPRelatedCard"
import CriminalRecordsCard from "./Cards/CriminalRecordsCard/CriminalRecordsCard"
import BACENCard from "./Cards/BACENCard/BACENCard"
import ArrestWarrantCard from "./Cards/ArrestWarrantCard/ArrestWarrantCard"
import CNJIneligibilityCard from "./Cards/CNJIneligibilityCard/CNJIneligibilityCard"
import CVMCard from "./Cards/CVMCard/CVMCard"
import FBICard from "./Cards/FBICard/FBICard"
import InterpolCard from "./Cards/InterpolCard/InterpolCard"
import IRCard from "./Cards/IRCard/IRCard"
import RiskAddressCard from "./Cards/RiskAddressCard/RiskAddressCard"
import UKCard from "./Cards/UKCard/UKCard"
import EUCard from "./Cards/EUCard/EUCard"
import RufraCard from "./Cards/RufraCard/RufraCard"
import DeloreanCard from "../Cards/DeloreanCard/DeloreanCard"
import WorldBankCard from "./Cards/WorldBankCard/WorldBankCard"
import PartnershipCard from "./Cards/PartnershipCard/PartnershipCard"
import CustomDataCard from "../Cards/CustomDataCard/CustomDataCard"
import Observation from "./Observation/Observation"
import moment from 'moment'
import ErrorBoundary from '../../Utils/ErrorBoundary'
import {useHistory} from 'react-router-dom'
import {getProperMetadata, checkNested} from "../utils/utils"
import History from "./History/History";
import PDFDownloadErrorDialog from "../utils/PDFDownload/PDFDownloadErrorDialog/PDFDownloadErrorDialog"
import PDFDownloadButton from "../utils/PDFDownload/PDFDownloadButton/PDFDownloadButton"
import PublicEmployeeCard from "./Cards/PublicEmployeeCard/PublicEmployeeCard";
import ElectoralDonorsCard from "./Cards/ElectoralDonorsCard/ElectoralDonorsCard";
import SocialAssistanceCard from "./Cards/SocialAssistanceCard/SocialAssistanceCard";
import CNDTCard from "./Cards/CNDTCard/CNDTCard";
import CNDFCard from "./Cards/CNDFCard/CNDFCard";
import LavaJatoCard from "./Cards/LavaJatoCard/LavaJatoCard";
import MilitaryRegistryCard from "../Cards/MilitaryRegistryCard/MilitaryRegistryCard";
import PassportCard from "../Cards/PassportCard/PassportCard";
import NationalMigrationRegistryCard from "../Cards/NationalMigrationRegistryCard/NationalMigrationRegistryCard";
import OthersCard from "../Cards/OthersCard/OthersCard";
import LetterOfEmancipationCard from "../Cards/LetterOfEmancipationCard/LetterOfEmancipationCard";
import ClassEntityRegistryCard from "../Cards/ClassEntityRegistryCard/ClassEntityRegistryCard";
import NationalRegistryOfForeignersCard from "../Cards/NationalRegistryOfForeignersCard/NationalRegistryOfForeignersCard";
import AdministrativeSanctionsCard from "./Cards/AdministrativeSanctionsCard";
import Serasa from "./Cards/SerasaCard/Serasa";
import EmailOtherAccounts from "../Cards/EmailOtherAccounts/EmailOtherAccounts";
import CinDigitalCard from "../Cards/CinDigitalCard/CinDigitalCard";
import AnalysedDocumentsCard from "./Cards/AnalysedDocumentsCard/AnalysedDocumentsCard";

function NaturalPerson(props) {
    let history = useHistory()
    let user_data = useContext(AuthContext).user_data
    if (
			!user_data.roles.includes("read_onboarding_natural_persons")&&
			!user_data.roles.includes("card_issuance_transaction_read_onboarding_natural_person_by_key")&&
			!user_data.roles.includes("card_issuance_alert_read_onboarding_natural_person_by_key")
		) {
			history.push("")
    }
	
	const [expandedSerasa, setExpandedSerasa] = useState(true)
    
	let { natural_person_key } = useParams();

    const [currentAnalyst, setCurrentAnalyst] = useState(null)

    const [natural_person, dispatchNaturalPerson] = useReducer(
        dataFetchReducer,
        {fetchedData: null, isLoading: true, isError: false} 
    )
	const [pdfErrorDialogOpen, setPDFErrorDialogOpen] = useState(false)

	const [pdfErrorDialogType, setPDFErrorDialogType] = useState("")
    const [snackBarOpen, setSnackBarOpen] = useState(true)

	const handlePDFErrorDialogOpen = (errorType) => {
		setPDFErrorDialogType(errorType)
		setPDFErrorDialogOpen(true)
	};
	
	const handlePDFErrorDialogClose = () => {
		setPDFErrorDialogType("")
		setPDFErrorDialogOpen(false)
	};

	const readabilityLevel = useMemo(() => {
		let level = 'full';
		if (user_data.roles.includes('onboarding_natural_person_idea_maker_analyst_t1')) {
			level = 'idea_maker_analyst_t1';
		}
		if (user_data.roles.includes('onboarding_natural_person_idea_maker_analyst_t2')) {
			level = 'idea_maker_analyst_t2';
		}
		if (user_data.roles.includes('onboarding_natural_person_idea_maker_analyst_strategy')) {
			level = 'full';
		}
		return level;
	}, [user_data.roles]);
	
    useEffect(() => {
		dispatchNaturalPerson({type: "data_fetch_init"})
		const timer = setTimeout(() => {
			axios.get('/dash/onboarding/natural_person/' + natural_person_key).then( response => {
                dispatchNaturalPerson({
                    type: "data_fetch_success",
                    payload: response.data
                })   
			}).catch(error => {
                if ((error.response || {}).status === 403) dispatchNaturalPerson({type: "data_fetch_failure_403"})
                else if ((error.response || {}).status === 404) dispatchNaturalPerson({type: "data_fetch_failure_404"})  
                else dispatchNaturalPerson({type: "data_fetch_failure"})    
			})	
		}, 500);
		return () => {
			clearTimeout(timer)
        }
    }, [natural_person_key])

	const analystHeartBeat = useCallback(
        () => {
			if (natural_person.fetchedData) {
				if (user_data.roles.includes("onboarding_analyst_heartbeat") && ["in_manual_analysis"].includes(natural_person.fetchedData.analysis_status)) {
					let payload = {}
					axios.put('/dash/onboarding/natural_person/' + natural_person_key + "/analyst_heartbeat", payload).then(response => {
						setCurrentAnalyst(response.data.analyst)
					}).catch(error => { console.log(error) })
				}
			}
        }, [natural_person.fetchedData, user_data.roles, natural_person_key]
    )

	useEffect(() => {
		analystHeartBeat(true)
		const timer = setInterval(() => {
			analystHeartBeat(true)
		}, 15000)
		return () => {
			clearInterval(timer)
			analystHeartBeat(false)
		}
    }, [analystHeartBeat])

 	if (natural_person.fetchedData) {
        let decision_metadata = getProperMetadata(natural_person.fetchedData.analysis_status_events)
        
		let hasAutomaticDecision = (natural_person.fetchedData.analysis_status === "automatically_approved" || natural_person.fetchedData.analysis_status === "automatically_reproved" ) 
		let showObservationCard = !hasAutomaticDecision

		const selectProcessesTable = (registration_date, decision_metadata) => {
			if (!(decision_metadata || {}).processes) return <></>
			const date = new Date(registration_date);
			const index_creation_date = new Date('2024-06-09T20:39:10Z');
			if (date.getTime() > index_creation_date.getTime()) {
				return (
					<div className="analysisCardContainer">
						<ErrorBoundary>
							<ProcessesEDPCard person_type={'natural_person'} person_key={natural_person_key} consolidated={decision_metadata.processes} company_key={natural_person.fetchedData?.company_key}/>
						</ErrorBoundary>
					</div> 
				);
			}

			return (
				<div className="analysisCardContainer">
					<ErrorBoundary>
						<ProcessesCard processes={decision_metadata.processes}/>
					</ErrorBoundary>
				</div> 
			);
		}
	

		const showCard = {
			partnership_card: checkNested(natural_person.fetchedData,"partnership_key"),
			rg_ocr_card: checkNested(natural_person.fetchedData,"documents","rg","ocr_front_key")||checkNested(natural_person.fetchedData,"documents","rg","ocr_back_key")||checkNested(natural_person.fetchedData,"documents","rg","ocr_key"),
			face_recon: checkNested(natural_person.fetchedData,"face","registration_key"),
			cnh_ocr_card: checkNested(natural_person.fetchedData,"documents","cnh","ocr_key")||checkNested(natural_person.fetchedData,"documents","cnh","ocr_front_key")||checkNested(natural_person.fetchedData,"documents","cnh","ocr_back_key"),
			letter_of_emancipation_ocr_card: checkNested(natural_person.fetchedData,"documents","letter_of_emancipation","ocr_key"),
			cin_digital_ocr_card: checkNested(natural_person.fetchedData,"documents","cin_digital","ocr_key"),
			analysed_documents_card: checkNested(natural_person.fetchedData, "documents")&&Object.entries(natural_person.fetchedData.documents).some(([_,value]) => Object.hasOwn(value, 'document_analysis_ids') || Object.hasOwn(value, 'document_analysis_id')),
			national_migration_registry_ocr_card: checkNested(natural_person.fetchedData,"documents","national_migration_registry","ocr_front_key")||checkNested(natural_person.fetchedData,"documents","national_migration_registry","ocr_back_key"),
			others_ocr_card: checkNested(natural_person.fetchedData,"documents","others","ocr_front_key")||checkNested(natural_person.fetchedData,"documents","others","ocr_back_key"),
			passport_ocr_card: checkNested(natural_person.fetchedData,"documents","passport","ocr_front_key")||checkNested(natural_person.fetchedData,"documents","passport","ocr_back_key")||checkNested(natural_person.fetchedData,"documents","passport","ocr_key"),
			cnh_profile: !!decision_metadata&&checkNested(decision_metadata,"cnh_database"),
			device_scan: checkNested(natural_person.fetchedData, "source", "session_id"),
			military_registry_ocr_card: checkNested(natural_person.fetchedData,"documents","military_registry","ocr_key"),
			class_entity_registry_ocr_card: checkNested(natural_person.fetchedData,"documents","class_entity_registry","ocr_key"),
			national_registry_of_foreigners_ocr_card: checkNested(natural_person.fetchedData,"documents","national_registry_of_foreigners","ocr_front_key")
		}
		let inputDataWidth = "50%"
		let outputDataWidth = "50%"
		if (showCard.rg_ocr_card||showCard.cnh_ocr_card||showCard.cnh_profile) {
			inputDataWidth = "60%"
			outputDataWidth = "40%"
		}

		return(
            <div style={{minWidth: "900px", overflow: "hidden", paddingBottom: "30px"}}>
                <div className="analysisCardContainer" style={{display:"flex"}}>
                    <ErrorBoundary>                    
                        <div>
                            <div className={["blueText", "titleSize"].join(" ")} style={{margin:"5px 0px"}}>
                                Análise {Object.keys(decision_metadata || {}).length === 0 ? 
                                'pendente no sistema' : (decision_metadata || {}).rule_identifier} - Pessoa Física 
                                {user_data.business_group_key == null ? null : "- " + natural_person.fetchedData.company_name}
                            </div>
                            <div className={["labelText", "subtitleSize"].join(" ")} style={{margin:"5px 0px", display: 'flex', flexDirection: "column"}}>
                                Cliente {natural_person.fetchedData.analyst_request === true ? 
                                    "requisitado por " + (natural_person.fetchedData.analysis_status_events || [{}])[0].analyst_name  + " no dia " + moment(natural_person.fetchedData.registration_date).format("DD/MM/YYYY")  + " às " + moment((natural_person.fetchedData.analysis_status_events || [{}])[0].event_date).format("HH:mm") :
                                    "#" + natural_person.fetchedData.id  + " registrado no dia " + moment(natural_person.fetchedData.registration_date).format("DD/MM/YYYY") + " às " + moment(natural_person.fetchedData.registration_date).format("HH:mm")}
									{" e analisado em " + moment(natural_person.fetchedData.created_at).format("DD/MM/YYYY") + " às " + moment(natural_person.fetchedData.created_at).format("HH:mm")}
								{natural_person.fetchedData.client_category && <span>Categoria: {natural_person.fetchedData.client_category}</span>}	
							</div>
                        </div>
						{user_data.roles.includes("read_pdf_onboarding") && readabilityLevel === 'full' ? 
							<div style={{margin: "auto 50px auto auto"}}>
                            	<PDFDownloadButton personKey={natural_person_key} person={natural_person.fetchedData} type={'natural'}
                                            dashAPIEndpointUrl={"/dash/onboarding/natural_person"}
                                            handlePDFDownloadErrorDialogOpenClick={handlePDFErrorDialogOpen}/>
                        	</div>
						:
						null}
                    </ErrorBoundary>
                </div>
            <div style={{display: "flex", margin: "10px 0px"}}>
            <div style={{width: inputDataWidth, display:"flex", flexDirection:"column"}}>
				{showCard.partnership_card&&
					<div style={{flexGrow: "1"}} className="analysisCardContainer">
						<ErrorBoundary>
							<PartnershipCard partnership_key={natural_person.fetchedData.partnership_key}/>
						</ErrorBoundary>
					</div>
				}
				<div className="analysisCardContainer" style={{flexGrow: "1", display: 'flex', flexDirection: 'column'}}>
					<ErrorBoundary>
						{natural_person.fetchedData.analyst_request === true ?
						<ClientProfileAnalyst natural_person={natural_person.fetchedData}/> :
						<ClientProfile natural_person={natural_person.fetchedData}/>}
					</ErrorBoundary>
				</div>
				{readabilityLevel === 'full' &&
					<>
						{showCard.cnh_ocr_card&&
						<div className="analysisCardContainer" style={{flexGrow: "1"}}>
						<ErrorBoundary>
							<CNHOCRCard cnh= {natural_person.fetchedData.documents.cnh} decision_metadata = {decision_metadata}/>
						</ErrorBoundary>
						</div>}
						{showCard.rg_ocr_card&&
						<div className="analysisCardContainer" style={{flexGrow: "1"}}>
						<ErrorBoundary>
							<RGOCRCard rg= {natural_person.fetchedData.documents.rg} decision_metadata = {decision_metadata}/>
						</ErrorBoundary>
						</div>}
						{showCard.national_migration_registry_ocr_card&&
						<div className="analysisCardContainer" style={{flexGrow: "1"}}>
						<ErrorBoundary>
							<NationalMigrationRegistryCard national_migration_registry= {natural_person.fetchedData.documents.national_migration_registry}/>
						</ErrorBoundary>
						</div>}
						{showCard.military_registry_ocr_card&&
						<div className="analysisCardContainer" style={{flexGrow: "1"}}>
						<ErrorBoundary>
							<MilitaryRegistryCard military_registry= {natural_person.fetchedData.documents.military_registry}/>
						</ErrorBoundary>
						</div>}
						{showCard.class_entity_registry_ocr_card&&
						<div className="analysisCardContainer" style={{flexGrow: "1"}}>
						<ErrorBoundary>
							<ClassEntityRegistryCard class_entity_registry= {natural_person.fetchedData.documents.class_entity_registry}/>
						</ErrorBoundary>
						</div>}
						{showCard.national_registry_of_foreigners_ocr_card&&
						<div className="analysisCardContainer" style={{flexGrow: "1"}}>
						<ErrorBoundary>
							<NationalRegistryOfForeignersCard national_registry_of_foreigners={natural_person.fetchedData.documents.national_registry_of_foreigners}/>
						</ErrorBoundary>
						</div>}
						{showCard.letter_of_emancipation_ocr_card&&
						<div className="analysisCardContainer" style={{flexGrow: "1"}}>
						<ErrorBoundary>
							<LetterOfEmancipationCard letter_of_emancipation={natural_person.fetchedData.documents.letter_of_emancipation}/>
						</ErrorBoundary>
						</div>}
						{showCard.cin_digital_ocr_card &&
						<div className="analysisCardContainer" style={{flexGrow: "1"}}>
						<ErrorBoundary>
							<CinDigitalCard cin_digital={natural_person.fetchedData.documents.cin_digital}/>
						</ErrorBoundary>
						</div>}
						{showCard.analysed_documents_card &&
						<div className="analysisCardContainer" style={{flexGrow: "1"}}>
						<ErrorBoundary>
							<AnalysedDocumentsCard documents={natural_person.fetchedData.documents} user_data={user_data}/>
						</ErrorBoundary>
						</div>}
						{showCard.others_ocr_card&&
						<div className="analysisCardContainer" style={{flexGrow: "1"}}>
						<ErrorBoundary>
							<OthersCard others={natural_person.fetchedData.documents.others}/>
						</ErrorBoundary>
						</div>}
						{showCard.passport_ocr_card&&
						<div className="analysisCardContainer" style={{flexGrow: "1"}}>
						<ErrorBoundary>
							<PassportCard passport={natural_person.fetchedData.documents.passport}/>
						</ErrorBoundary>
						</div>}
						{showCard.cnh_profile ?
						<div className="analysisCardContainer" style={{flexGrow: "1"}}>
						<ErrorBoundary>
							<CNHProfile natural_person={natural_person.fetchedData}/>
						</ErrorBoundary>
						</div> : null}
						{showCard.device_scan ?
						<div style={{flexGrow: "1", flexDirection: "column"}} className="analysisCardContainer">
							<ErrorBoundary>
								<DeviceScan natural_person={natural_person.fetchedData}/>
							</ErrorBoundary>
						</div>	: null}
						{natural_person.fetchedData.custom_data&&
						<div className="analysisCardContainer" style={{flexGrow: "1"}}>
							<ErrorBoundary>
								<CustomDataCard data={natural_person.fetchedData} />
							</ErrorBoundary>
						</div>}
					</>
				}
			</div>
					<div style={{width: outputDataWidth, display:"flex", flexDirection:"column"}}>
						<div style={{flexGrow: "1"}} className="analysisCardContainer">
							<ErrorBoundary>
								<Summary natural_person={natural_person.fetchedData} readabilityLevel={readabilityLevel}/>
							</ErrorBoundary>
						</div>
						{['idea_maker_analyst_t2', 'full'].includes(readabilityLevel) && ((decision_metadata || {}).indicators || []).length > 0 ?
						<div style={{flexGrow: "1"}} className="analysisCardContainer">
							<ErrorBoundary>
								<Indicators indicators={decision_metadata.indicators}/>
							</ErrorBoundary>
						</div>	: null}
					</div>
				</div>
				{readabilityLevel === 'full' && 
					<>
						{ decision_metadata && decision_metadata.checker_rufra_data ?
						<div className="analysisCardContainer" style={{flexGrow: "1"}}>
							<ErrorBoundary>
								<RufraCard rufra_data={decision_metadata.checker_rufra_data}/>
							</ErrorBoundary>
						</div>
						: null}
						{
							decision_metadata && decision_metadata.delorean &&
							<div className="analysisCardContainer" style={{flexGrow: "1"}}>
								<ErrorBoundary>
									<DeloreanCard rufra_data={decision_metadata.delorean}/>
								</ErrorBoundary>
							</div> 
						}
						<div>
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<History naturalPerson={natural_person.fetchedData}/>
								</ErrorBoundary>
							</div>
						</div>
						<div>
							{(decision_metadata || {}).related_people ? 
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<PeopleRelatedCard related_people={decision_metadata.related_people}/>
								</ErrorBoundary>
							</div> : null} 
							{(decision_metadata || {}).related_companies ? 
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<CompaniesRelatedCard related_companies={decision_metadata.related_companies}/>
								</ErrorBoundary>
							</div> : null} 
							{(decision_metadata || {}).social_assistance &&
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<SocialAssistanceCard social_assistance={decision_metadata.social_assistance}/>
								</ErrorBoundary>
							</div>
							}
							{(decision_metadata || {}).lava_jato ? 
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<LavaJatoCard lava_jato={decision_metadata.lava_jato}/>
								</ErrorBoundary>
							</div> : null} 
							{(decision_metadata || {}).email_other_accounts ?
							<div className="analysisCardContainer" style={{flexGrow: "1"}}>
								<ErrorBoundary>
									<EmailOtherAccounts email_other_accounts_data={decision_metadata.email_other_accounts}/>
								</ErrorBoundary>
							</div> : null}
							{(decision_metadata || {}).electoral_donors &&
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<ElectoralDonorsCard electoral_donors={decision_metadata.electoral_donors}/>
								</ErrorBoundary>
							</div>
							}
							{(decision_metadata || {}).public_employee &&
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<PublicEmployeeCard public_employee={decision_metadata.public_employee}/>
								</ErrorBoundary>
							</div>
							}
							{(decision_metadata || {}).media_exposure ?
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<MediaCard media_exposure={decision_metadata.media_exposure}/>
								</ErrorBoundary>
							</div> : null}
							{(decision_metadata || {}).clip_laundering ?
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<ClipLaunderingCard clip_laundering_data={decision_metadata.clip_laundering}/>
								</ErrorBoundary>
							</div> : null}
							{(decision_metadata || {}).sports_exposure ?
								<div className="analysisCardContainer">
									<ErrorBoundary>
										<SportsExposureCard sports_exposure={decision_metadata.sports_exposure}/>
									</ErrorBoundary>
								</div> : <></>
							}

							{selectProcessesTable(natural_person.fetchedData.registration_date, decision_metadata)}
							{((decision_metadata || {}).ceaf || (decision_metadata || {}).cepim || (decision_metadata || {}).ceis || (decision_metadata || {}).cnep) &&
								<ErrorBoundary>
									<AdministrativeSanctionsCard cepim={(decision_metadata || {}).cepim} ceis={(decision_metadata || {}).ceis} cnep={(decision_metadata || {}).cnep} ceaf={(decision_metadata || {}).ceaf}/>
								</ErrorBoundary>
							}
							{(decision_metadata || {}).dafn ?
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<DAFNCard dafn={decision_metadata.dafn}/>
								</ErrorBoundary>
							</div> : null}
							{(decision_metadata || {}).ibama ?
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<IbamaCard ibama={decision_metadata.ibama}/>
								</ErrorBoundary>
							</div> : null}
							{(decision_metadata || {}).protests ?
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<ProtestsCard protests={decision_metadata.protests}/>
								</ErrorBoundary>
							</div> : null}
							{(decision_metadata || {}).slavery ?
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<SlaveryCard slavery={decision_metadata.slavery}/>
								</ErrorBoundary>
							</div> : null}
							{(decision_metadata || {}).ofac ?
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<OFACCard ofac={decision_metadata.ofac}/>
								</ErrorBoundary>
							</div> : null}
							{(decision_metadata || {}).unsc ?
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<UNSCCard unsc={decision_metadata.unsc}/>
								</ErrorBoundary>
							</div> : null}
							{(decision_metadata || {}).pep ?
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<PEPCard pep={decision_metadata.pep}/>
								</ErrorBoundary>
							</div> : null}
							{(decision_metadata || {}).related_pep ?
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<PEPRelatedCard related_pep={decision_metadata.related_pep}/>
								</ErrorBoundary>
							</div> : null}
							{(decision_metadata || {}).criminal_records ?
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<CriminalRecordsCard criminal_records={decision_metadata.criminal_records}/>
								</ErrorBoundary>
							</div> : null}
							{(decision_metadata || {}).bacen ?
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<BACENCard bacen={decision_metadata.bacen}/>
								</ErrorBoundary>
							</div> : null}
							{((decision_metadata || {}).arrest_warrant || {}).data ?
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<ArrestWarrantCard arrest_warrant={decision_metadata.arrest_warrant}/>
								</ErrorBoundary>
							</div> : null}
							{(decision_metadata || {}).cnj_ineligibility ?
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<CNJIneligibilityCard cnj_ineligibility={decision_metadata.cnj_ineligibility}/>
								</ErrorBoundary>
							</div> : null}
							{(decision_metadata || {}).cvm ?
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<CVMCard cvm={decision_metadata.cvm}/>
								</ErrorBoundary>
							</div> : null}
							{(decision_metadata || {}).fbi ?
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<FBICard fbi={decision_metadata.fbi}/>
								</ErrorBoundary>
							</div> : null}
							{(decision_metadata || {}).interpol ?
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<InterpolCard interpol={decision_metadata.interpol}/>
								</ErrorBoundary>
							</div> : null}
							{(decision_metadata || {}).risk_address ?
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<RiskAddressCard risk_address={decision_metadata.risk_address}/>
								</ErrorBoundary>
							</div> : null}
							{((decision_metadata || {}).receita_federal_status || {}).fiscal_situation ?
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<IRCard receita_federal_status={decision_metadata.receita_federal_status}/>
								</ErrorBoundary>
							</div> : null}
							{(decision_metadata || {}).uk_sanctions ?
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<UKCard unitedKingdom={decision_metadata.uk_sanctions}/>
								</ErrorBoundary>
							</div> : null}
							{(decision_metadata || {}).eu_sanctions ?
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<EUCard europeUnion={decision_metadata.eu_sanctions}/>
								</ErrorBoundary>
							</div> : null}
							{(decision_metadata || {}).world_bank ?
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<WorldBankCard worldBank={decision_metadata.world_bank}/>
								</ErrorBoundary>
							</div> : null}
							{(decision_metadata || {}).cndt ?
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<CNDTCard cndt={decision_metadata.cndt}/>
								</ErrorBoundary>
							</div> : null}
							{(decision_metadata || {}).cndf ?
							<div className="analysisCardContainer">
								<ErrorBoundary>
									<CNDFCard cndf={decision_metadata.cndf}/>
								</ErrorBoundary>
							</div> : null}
							{(decision_metadata || {}).serasa?.document_number && [
								'3d949b77-0c91-45ce-abce-ac6be3638fc9', // Production - Seven Pounds
								'64520138-3e5b-4c2a-856a-33e1b199b0cb', // Sandbox - Zaig
								'249dc6e3-b1db-4500-ba0c-4e7ab2d378fd', // Visagio - POC
								'123-123-123' // Local - Test Company
							].includes(user_data.company_key) &&
								<div className="analysisCardContainer">
									<Serasa
									serasa={decision_metadata.serasa}
									setExpandedSerasa={setExpandedSerasa}
									expandedSerasa={expandedSerasa}
									/>
								</div>
							}
						</div>
					</>
				}
				{showObservationCard && 
					<div className="analysisCardContainer">
						<ErrorBoundary>
							<Observation natural_person={natural_person.fetchedData} natural_person_key={natural_person_key} user_data={user_data}/>
						</ErrorBoundary>
					</div>}
				{["in_manual_analysis"].includes(natural_person.fetchedData.analysis_status) && user_data.roles.includes("onboarding_analyst_heartbeat") && currentAnalyst != null ?
					<AnalystSnackBar
						currentAnalyst={currentAnalyst}
						open={snackBarOpen}
						onClose={() => setSnackBarOpen(false)}
					/> : null}
				<PDFDownloadErrorDialog 
					open={pdfErrorDialogOpen}
					onClose={handlePDFErrorDialogClose}
					errorType={pdfErrorDialogType}
				/>
			</div>
		);
	}
    else if (natural_person.isLoading) {
		return(
			<div style={{ width: "auto" }}>
				<div className='circularProgressCenter'>
					<CircularProgress />
				</div>
			</div>
		)
    }
	else if(natural_person.isError){
		return (
            <div style={{height: "80vh", display:"flex"}}>
                <p className={["blueText", "titleSize"].join(" ")} style={{margin:"auto", textAlign:"center"}}>
                    {natural_person.errorMessage}
                </p>
            </div>
		)
	}
  
  return null;
}

export default NaturalPerson;
